// @ts-nocheck
 
 
 
 
 
/* eslint-disable import/order */
 
 
 
/* eslint-disable react/jsx-newline */
 
 
 
 
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import  OrganisationBanksTable  from './OrganisationBankTable';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
import AddOrganisationBanks from './addOrganisationBank';
import EditOrganisationBanks from './updateOrganisationBank';
import ViewOrganisationBanks from './view-OrganisationBank';

const OrganisationBanks: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasOrganisationBanksAddAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'OrganisationBanks')
  );

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasOrganisationBanksAddAccess ? <AddOrganisationBanks/> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id/edit`}>
        {hasOrganisationBanksAddAccess ? <EditOrganisationBanks/> : <NotAuthorized />}
        </Route>
        <Route path={`${baseURL}/:id`}>
         <ViewOrganisationBanks/>
        </Route>
        <Route exact path={`${baseURL}`}>
          <OrganisationBanksTable/>
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { OrganisationBanks };
